import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import makeRootReducer from './reducers'
import epics from '../epics'
import {createEpicMiddleware, combineEpics} from 'redux-observable'
import reduxLocalStorageEnhancer from '../store/localStorage'

export default (initialState = {}, history) => {

  const rootEpic = combineEpics(...epics)

  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [thunk, routerMiddleware(history), createEpicMiddleware(rootEpic)]

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [
    reduxLocalStorageEnhancer
  ]
  if (__DEBUG__) {
    const devToolsExtension = window.devToolsExtension
    if (typeof devToolsExtension === 'function') {
      enhancers.push(devToolsExtension())
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(
    makeRootReducer(),
    initialState,
    compose(
      applyMiddleware(...middleware),
      ...enhancers
    )
  )
  store.asyncReducers = {}

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default
      store.replaceReducer(reducers(store.asyncReducers))
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./src/store/createStore.js